<template>
  <div class="father">
    <div class="title">选择卷</div>
    <div class="template-body">
      <div class="template-body-main">
        <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%;float: left;">
          <!-- 卷模板 -->
          <div v-if="active == 0" style="padding:20px">
            <div v-for="(item, index) in CouponList" :key="index" :class="index == clicked
              ? 'template-body-main-item template-body-main-item-clicked'
              : 'template-body-main-item '
              ">
              <div @click="clickTemp(index, item)">
                <!-- 卷模板样式组件 -->
                <couponTemplate :coupon="item.key" :datas="item"></couponTemplate>
              </div>
            </div>
          </div>
          <!-- 卷信息修改 -->
          <!-- <div v-if="active == 1" style="padding:20px">
            <createCouponForm :coupon_data="CouponList[clicked]"></createCouponForm>
          </div> -->
        </el-scrollbar>
      </div>
    </div>
    <div class="bottom-btn">
      <el-button type="primary" style="width: 300px;" @click="createCoupon">确定</el-button>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { GetCardClassify, testRes } from "@/api/index";
import { mapMutations } from "vuex";
import { couponList } from "../js/couponList";
import createCard from "@/components/createCard.vue";
import wtyTemplate from "@/pages/shop/pages/vip/components/wty-template.vue";
import couponTemplate from "../components/couponTemplate.vue";
import createCouponForm from "../components/createCouponForm.vue";
// import { getBusifavorCouponInfo } from "../../js/couponInfo.js";
/* eslint-disable */
export default {
  components: {
    createCard,
    wtyTemplate,
    couponTemplate,
    createCouponForm
  },
  data() {
    return {
      active: 0, //步骤条在第几步
      dialogVisible: false, //model组件是否显示
      alltemplate: [],
      CouponList: couponList, //卷列表
      ckeyWords: [],
      clicked: 0,
      temp_data: {}
    };
  },
  async mounted() {
    this.clickTemp(0, couponList[0])
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS", "ADDTABS"]),
    /**
     * 点击确定生成卡卷
     */
    createCoupon() {
      this.UPDATEMENUTABS("/couponForm");
      console.log("temp_data", this.temp_data);
      this.$router.push({ name: 'couponForm', params: { key: 'create', value: JSON.stringify(this.temp_data) } });

      this.ADDTABS({
        activePath: "/couponForm",
        title: "优惠券详情"
      });
    },
    /**
         * 选中的模板
         * @param {*} index 索引
         * @param {*} datas 模板数据
         */
    clickTemp(index, datas) {
      this.clicked = index;
      this.temp_data = datas;
      console.log("选择的卷模板", this.temp_data);
    },
    /**
     * 不在修改
     * @param key
     */
    stepsChange(key) {
      if (key === "+") {
        this.active++;
      } else if (key === "-") {
        this.active--;
      }
    },
    /**
     * 确定按钮
     */
    chooseTemp() {
      this.$emit("wtyTemplateReturn", this.CouponList[this.clicked]);
    },
    /**
     * 修改类别返回
     * @param keywords
     */
    classChange(keywords) {
      console.log("keywords", keywords);
      console.log("keywords", this.ckeyWords.includes(keywords));
      if (this.ckeyWords.includes(keywords)) {
        var a = [];
        for (let i = 0; i < this.ckeyWords.length; i++) {
          if (this.ckeyWords[i] !== keywords) {
            a.push(this.ckeyWords[i]);
          }
        }
        this.ckeyWords = a;
      } else {
        this.ckeyWords.unshift(keywords);
      }
      this.$emit("wtyTemplateReturn", this.ckeyWords);
    },
    searchTemplate() { },
    handleClose(done) {
      this.dialogVisible = false;

      /* this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {}); */
    },
    showDialog() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.father {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 99%;
  background-color: #fff;
  margin: 0px;
  padding: 20px;
  display: flex;
  flex-direction: column;

}

/* .bottom-btn {
  width: 100%;
  display: flex;
  justify-content: end;
} */

.template-body {
  width: 100%;
  height: 70vh;
  // background-color: rgba(178, 37, 37, 0.3);

  &-class {
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-l-f {
      display: flex;
      align-items: center;
      width: calc(100% - 185px);
      height: 40px;
      scrollbar-width: none;
      padding: 0 10px 0 0;

      &-span {
        margin: 0 10px 0 0;
        color: #606266;
        cursor: pointer;
        user-select: none;
      }

      &-clicked {
        color: #409eff;
        font-weight: 700;
      }
    }

    &-father {
      min-width: 1500px;
    }

    &-item {
      display: inline-block;
      height: 40px;
    }
  }

  &-main {
    height: 100%;
    width: 100%;
    padding: 10px 0;

    &-item {
      display: inline-block;
      width: auto;
      height: auto;
      background-color: transparent;
      margin: 0 10px 10px 0;
      padding: 10px;
      border-radius: 24px;
    }

    .template-body-main-item-clicked {
      //  0 0 20px #8b8b8b;
      transform: translate3d(0, 0, 20px);
      transform: scale(1.01);
      transition: all 0.5s;
      // border-bottom: 1px solid #000;;
      box-shadow: inset 0 0 30px #ffc800;
    }
  }

  &-main-empty {
    height: calc(100% - 40px);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
}

.dialog-footer {
  height: 60px;
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 0 20px;

  .footer-button {
    width: 100px;
  }
}

/deep/.el-dialog__header {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-dialog__footer {
  padding: 10px 20px;
}

/deep/ .el-dialog__headerbtn {
  top: 13px;
}

/deep/.el-input-group__append {
  padding: 0 10px !important;
}

/deep/.el-input {
  width: 185px !important;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;

  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }

  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
